import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BASE_URL } from "./Config";
import logo from "./img/logo512.png"; 
import login_bg from "./img/login-bg.jpg";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationErrors({});
    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/api/login`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      const { user, authorisation } = response.data;
      const token = authorisation?.token;

      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("user_id", user.id);
        localStorage.setItem("user_name", user.name);
        localStorage.setItem("role", user.role);

        Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: `Welcome back, ${user.name}!`,
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          if (user.role === 3) navigate("/admin");
          else if (user.role === 2) navigate("/member");
          else navigate("/");
        });
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          Swal.fire({
            icon: "error",
            title: "Login Failed",
            text: "Invalid email or password.",
          });
        } else if (status === 422) {
          setValidationErrors(data.errors || {});
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong. Please try again later.",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Network Error",
          text: "Please check your internet connection.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* External CSS */}
      <link
        href={`${process.env.PUBLIC_URL}/assets/css/sb-admin-2.min.css`}
        rel="stylesheet"
      />
      <link
        href={`${process.env.PUBLIC_URL}/assets/vendor/fontawesome-free/css/all.min.css`}
        rel="stylesheet"
      />

      {/* Login Page */}
      <div
        className="bg-gradient-primary d-flex align-items-center justify-content-center"
        style={{ height: "100vh", backgroundImage: `url(${login_bg})`, backgroundSize: "cover" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="card o-hidden border-0 shadow-lg my-5">
                <div className="card-body p-0">
                  <div className="row">
                    <div className="col-lg-12 text-center p-4">
                      <img
                        src={logo}
                        alt="Logo"
                        className="img-fluid mb-3"
                        style={{ maxWidth: "120px" }}
                      />
                      <h1 className="h4 text-gray-900 mb-4">Login</h1>
                    </div>
                    <div className="col-lg-12">
                      <div className="p-5">
                        <form className="user" onSubmit={handleSubmit} noValidate>
                          {/* Email */}
                          <div className="form-group mb-3">
                            <label htmlFor="email" className="form-label">
                              Email Address
                            </label>
                            <input
                              type="email"
                              name="email"
                              id="email"
                              value={formData.email}
                              onChange={handleChange}
                              className={`form-control ${validationErrors.email ? "is-invalid" : ""}`}
                              placeholder="Enter your email"
                              required
                              autoFocus
                            />
                            {validationErrors.email && (
                              <div className="invalid-feedback">{validationErrors.email[0]}</div>
                            )}
                          </div>

                          {/* Password */}
                          <div className="form-group mb-3">
                            <label htmlFor="password" className="form-label">
                              Password
                            </label>
                            <input
                              type="password"
                              name="password"
                              id="password"
                              value={formData.password}
                              onChange={handleChange}
                              className={`form-control ${validationErrors.password ? "is-invalid" : ""}`}
                              placeholder="Enter your password"
                              required
                            />
                            {validationErrors.password && (
                              <div className="invalid-feedback">{validationErrors.password[0]}</div>
                            )}
                          </div>

                          {/* Submit */}
                          <button
                            type="submit"
                            className="btn btn-primary btn-user w-100"
                            disabled={loading}
                          >
                            {loading ? "Logging in..." : "Login"}
                          </button>
                        </form>

                        <hr />
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </>
  );
};

export default Login;
